import {ConsultationItem, ConsultationModalType} from "../../../../types/consultation";
import style from "../../../../assets/scss/sub/consultantHistory.module.scss";
import statusStyle from "../../../../assets/scss/common/modal/addConsultationModal.module.scss";
import React from "react";
import {useTranslation} from "react-i18next";

export function useConsultationFunctions() {
    const { t } = useTranslation("consultant");
    const getStatusMessage = (status?: string) => {
        if (!status) return t("btn.apply");

        switch (status?.toLowerCase()) {
            case "refunded":
                return t('detail.row.refunded');
            case "allotted":
                return t('detail.row.allotted');
            case "finished":
                return t('detail.row.finished');
            case "not_allotted":
                return t('detail.row.notAllotted');
            default:
                return "싱담신청";
        }
    }

    const getConsultationStatus = (status?: string) =>{
        switch (status) {
            case "NOT_ALLOTTED":
                return <span className={statusStyle.innerTextDesc}>{t('detail.row.notAllotted')}</span>;
            case "ALLOTTED":
                return <span className={statusStyle.purpleText}>{t('detail.row.allotted')}</span>;
            case "FINISHED":
                return <span className={statusStyle.redText}>{t('detail.row.finished')}</span>;
            case "REFUNDED":
                return <span className={statusStyle.redText}>{t('detail.row.refunded')}</span>;
            case "CANCELED":
                return <span className={statusStyle.redText}>{t('detail.row.canceled')}</span>;
            default:
                return <span>테스트</span>;
        }
    }

    const getButtonContent = (
        item:ConsultationItem,
        toggleModal: (params: {
            consultation: ConsultationItem | null,
            modalType: ConsultationModalType
        }) => void
    ) => {
        switch (item.status?.toLowerCase()) {
            case "finished":
                return (
                    <button
                        className={item.reviewWritten ? style.consultReviewBtn : style.consultBtn}
                        onClick={() => toggleModal({consultation: item, modalType: ConsultationModalType.REVIEW})}>
                        {t('btn.review')}
                    </button>
                );
            case "not_allotted":
                return (
                    <button className={style.consultBtn}
                            onClick={() =>
                                toggleModal({consultation: item, modalType: ConsultationModalType.EDIT})
                            }>
                        {t('btn.detail')}
                    </button>
                )
            case "allotted":
                return (
                    <button className={style.consultBtn}
                            onClick={() =>
                                toggleModal({consultation: item, modalType: ConsultationModalType.DETAIL})
                            }>
                        {t('btn.detail')}
                    </button>
                )
            default:
                return <>-</>
        }
    };




    return {
        getButtonContent, getStatusMessage, getConsultationStatus
    }
}